import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'catalyst-backed' | 'momentum' | 'none' | 'normal' | 'warning' | 'info';
  dot?: boolean;
  className?: string;
}

const VARIANTS = {
  'catalyst-backed': {
    pill: 'bg-emerald-50  dark:bg-[#10d98e]/10  text-emerald-700 dark:text-[#10d98e]  border-emerald-200  dark:border-[#10d98e]/25',
    dot:  'bg-emerald-500 dark:bg-[#10d98e]',
  },
  'momentum': {
    pill: 'bg-amber-50   dark:bg-amber-400/10  text-amber-700  dark:text-amber-400   border-amber-200   dark:border-amber-400/25',
    dot:  'bg-amber-400',
  },
  'none': {
    pill: 'bg-red-50     dark:bg-[#f5476a]/10  text-red-600    dark:text-[#f5476a]   border-red-200     dark:border-[#f5476a]/25',
    dot:  'bg-red-500 dark:bg-[#f5476a]',
  },
  'normal': {
    pill: 'bg-gray-50    dark:bg-[#1d2d47]/50  text-gray-600   dark:text-[#c2d0e0]   border-gray-200    dark:border-[#1d2d47]',
    dot:  'bg-gray-400 dark:bg-[#a3b6cc]',
  },
  'warning': {
    pill: 'bg-orange-50  dark:bg-orange-400/10 text-orange-700 dark:text-orange-400  border-orange-200  dark:border-orange-400/25',
    dot:  'bg-orange-400',
  },
  'info': {
    pill: 'bg-blue-50    dark:bg-[#4f8ff8]/10  text-blue-700   dark:text-[#4f8ff8]   border-blue-200    dark:border-[#4f8ff8]/25',
    dot:  'bg-blue-500 dark:bg-[#4f8ff8]',
  },
};

export default function Badge({
  children,
  variant = 'normal',
  dot = false,
  className = '',
}: BadgeProps) {
  const cfg = VARIANTS[variant] ?? VARIANTS['normal'];

  return (
    <span
      className={`
        inline-flex items-center gap-1.5
        px-2.5 py-0.5 rounded-lg
        text-[11px] font-semibold
        border
        ${cfg.pill}
        ${className}
      `}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${cfg.dot}`} />}
      {children}
    </span>
  );
}
